import Enumerator from './Enumerator';

export const propertyTypes = [
  'none',
  'apartment_unit_flat',
  'company_title_unit',
  'duplex',
  'fully_detached_house',
  'holiday_home',
  'holiday_rental',
  'house_and_land',
  'licensed_builder_construction',
  'owner_builder_construction',
  'semi_detached_house',
  'serviced_apartment',
  'single_bedroom_less_than_fifty_sqm',
  'strata_title_unit',
  'townhouse',
  'vacant_land',
  'villa'
];

export class PropertyType extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
      case 'p1':
        correctOption = 'apartment_unit_flat';
        break;
      case '2':
        correctOption = 'fully_detached_house';
        break;
      case '3':
        correctOption = 'semi_detached_house';
        break;
      case '4':
        correctOption = 'duplex';
        break;
      case '5':
        correctOption = 'townhouse';
        break;
      case '6':
        correctOption = 'serviced_apartment';
        break;
      case '7':
        correctOption = 'strata_title_unit';
        break;
      case '8':
        correctOption = 'company_title_unit';
        break;
      case '9':
        correctOption = 'single_bedroom_less_than_fifty_sqm';
        break;
      case '10':
        correctOption = 'holiday_home';
        break;
      case '11':
        correctOption = 'holiday_rental';
        break;
      case '12':
        correctOption = 'villa';
        break;
      case '13':
      case 'p3':
        correctOption = 'vacant_land';
        break;
      case '14':
      case 'p4':
        correctOption = 'licensed_builder_construction';
        break;
      case '15':
        correctOption = 'owner_builder_construction';
        break;
      case '16':
      case 'p2':
        correctOption = 'house_and_land';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

PropertyType.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  apartment_unit_flat: {
    get title() {
      return 'Apartment/Unit/Flat';
    }
  },
  company_title_unit: {
    get title() {
      return 'Company title unit';
    }
  },
  duplex: {
    get title() {
      return 'Duplex';
    }
  },
  fully_detached_house: {
    get title() {
      return 'Fully detached house';
    }
  },
  holiday_home: {
    get title() {
      return 'Holiday home';
    }
  },
  holiday_rental: {
    get title() {
      return 'Holiday rental';
    }
  },
  house_and_land: {
    get title() {
      return 'House and land';
    }
  },
  licensed_builder_construction: {
    get title() {
      return 'Licensed builder construction';
    }
  },
  owner_builder_construction: {
    get title() {
      return 'Owner builder construction';
    }
  },
  semi_detached_house: {
    get title() {
      return 'Semi detached house';
    }
  },
  serviced_apartment: {
    get title() {
      return 'Serviced apartment';
    }
  },
  single_bedroom_less_than_fifty_sqm: {
    get title() {
      return 'Single bedroom < 50sqm';
    }
  },
  strata_title_unit: {
    get title() {
      return 'Strata title unit';
    }
  },
  townhouse: {
    get title() {
      return 'Townhouse';
    }
  },
  vacant_land: {
    get title() {
      return 'Vacant land';
    }
  },
  villa: {
    get title() {
      return 'Villa';
    }
  }
});

export default {
  propertyTypes,
  PropertyType
};
